export const formatTimeInterval = seconds => {
    const steps = [
        {
            label: 's',
            factor: 60,
        },
        {
            label: 'min',
            factor: 60,
        },
        {
            label: 'h',
            factor: 24,
        },
        {
            label: 'd',
            factor: null,
        },
    ];

    let remaining = Math.abs(Math.round(seconds));
    let parts = [];

    for (const { label, factor } of steps) {
        const value = factor ? remaining % factor : remaining;
        parts.push(`${value}${label}`);
        if (factor) {
            remaining = Math.floor(remaining / factor);
        }
        if (remaining <= 0) {
            break;
        }
    }

    return parts.toReversed().join(' ');
};

export const formatIntervalSince = dateStr => {
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const diffInMinutes = Math.round(diff / 1000 / 60) * 60;
    return formatTimeInterval(diffInMinutes)
        .split(' ')
        .filter(part => !part.endsWith('s'))
        .join(' ');
};
